import { Directive } from '@angular/core';

@Directive({
    selector: 'app-form-field-error',
    host: {
        style: 'display: block',
    },
    standalone: false,
})
export class FormFieldErrorDirective {
}
